exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-71f1aa7d] tbody td{\n    cursor: pointer;\n}\n[data-v-71f1aa7d] tbody td td.non-clickable{\n    cursor: auto;\n}\n.container[data-v-71f1aa7d]{\n    max-width: 100vw;\n}\n", ""]);

// exports
